module.exports = __webpack_public_path__ + "img/fb-icon.741a6a47.svg";